import React from 'react';

// Sayı formatlama fonksiyonu
export const formatNumber = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const getCounterData = (siteData) => {
  if (!siteData?.siteSettings) {
    return {
      trees: {
        target: 1400000,
        label: '1 Yıllık Ağaç Hedefi',
        prefix: '~',
        suffix: ''
      },
      customers: {
        target: 127930,
        label: (
          <>
            Fidan Bağışı <small>(Ağustos Ayı İtibarıyla)</small>
          </>
        ),
        prefix: '',
        suffix: ''
      },
      years: {
        target: 108,
        label: (<>
        Hektar <small>(Ağustos Ayı İtibarıyla)</small>
        </>),
        prefix: '~',
        suffix: ''
      }
    };
  }

  const decodeHtml = (html) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  };

  return {
    trees: {
      target: parseInt(siteData.siteSettings.map_box_one_count) || 1400000,
      label: decodeHtml(siteData.siteSettings.map_box_one_title),
      prefix: '~',
      suffix: '',
      isHtml: true
    },
    customers: {
      target: parseInt(siteData.siteSettings.map_box_two_count) || 127930,
      label: decodeHtml(siteData.siteSettings.map_box_two_title),
      prefix: '',
      suffix: '',
      isHtml: true
    },
    years: {
      target: parseInt(siteData.siteSettings.map_box_three_count) || 108,
      label: decodeHtml(siteData.siteSettings.map_box_three_title),
      prefix: '~',
      suffix: '',
      isHtml: true
    }
  };
};

// Backward compatibility için eski counterData'yı da export ediyoruz
export const counterData = {
  trees: {
    target: 1400000,
    label: '1 Yıllık Ağaç Hedefi',
    prefix: '~',
    suffix: ''
  },
  customers: {
    target: 127930,
    label: (
      <>
        Fidan Bağışı <small>(Ağustos Ayı İtibarıyla)</small>
      </>
    ),
    prefix: '',
    suffix: ''
  },
  years: {
    target: 108,
    label: (<>
    Hektar <small>(Ağustos Ayı İtibarıyla)</small>
    </>),
    prefix: '~',
    suffix: ''
  }
};

export const getTargetNumbers = () => {
  const targetNumbers = {};
  Object.keys(counterData).forEach(key => {
    targetNumbers[key] = counterData[key].target;
  });
  return targetNumbers;
};
